import { createContext } from "react";
import type { ThemeMode } from "../../layouts/themes";
import type { Theme } from "@mui/material";
import type { ThemeList } from "api";

type ThemeContextType = {
  mode: ThemeMode;
  setMode: (mode: ThemeMode) => unknown;
  themes: ThemeList;
  muiTheme: Theme;
  muiThemes: {
    light: Theme;
    dark: Theme;
  };
};

export const ThemeContext = createContext<ThemeContextType>({
  mode: "light",
  setMode: () => {},
  themes: {} as ThemeList,
  muiTheme: {} as Theme,
  muiThemes: { light: {} as Theme, dark: {} as Theme },
});
